import { reducer as formReducer } from 'redux-form';
import { combineReducers } from 'redux';

import dashboard from './screens/Dashboard/reducer';
import chargersList from './screens/ChargersList/reducer';
import login from './screens/Login/reducer';
import rapidSearch from './screens/Dashboard/components/RapidSearch/reducer';
import accounts from './screens/AdminTools/components/Accounts/reducers';
import profile from './screens/Profile/reducer';
import statistics from './screens/HomePage/reducer';
import chargerDetails from './screens/ChargerDetails/reducer';
import dictionaries from './screens/AdminTools/components/Dictionary/reducer';
import ssplists from './common/components/SSPList/reducer';
import appConfig from './common/components/appConfig/reducer';
import firmwareUpdateDialog from './screens/ChargerDetails/components/FirmwareUpdateDialog/reducer';
import { reducer as idle } from './common/services/ReduxIdleMonitor';
import multiFwUpdateList from './screens/MultiFwUpdate/reducer';
import drillDownChart from './screens/Reports/components/DrillDownChart/reducer';
import plazaTopology from './screens/PlazaView/components/Editor/reducer';
import logEvents from './screens/PlazaView/components/LogEvents/reducer';
import plazaGraphs from './screens/PlazaView/components/Graphs/store/reducer';
import plazaChargerList from './screens/PlazaView/components/PlazaChargerList/reducer';
import parametersSchema from './screens/AdminTools/components/ParametersSchema/reducers';
import { roles } from './screens/Roles';
import deployCheck from './common/services/deployCheck/reducers';
import advancedSearch from './common/components/AdvancedSearch/reducer';
import plazaView from './screens/PlazaView/reducer';
import fwPackages from './screens/AdminTools/components/FWPackagesDictionary/reducers';
import chargerPackages from './screens/ChargerDetails/components/ChargerPackages/reducer';
import reports from './screens/Reports/reducer';
import alert from './common/components/Alert/reducer';
import notification from './common/components/Notification/reducer';
import confirm from './common/components/Confirm/reducer';
import screenBlocker from './common/components/ScreenBlocker/reducer';
import ssoAccounts from './screens/AdminTools/components/SSOAccounts/reducer';
import ChargerTelemetryReducer from './screens/ChargerDetails/components/Telemetry/store/reducer';
import telemetryMetrics from './screens/AdminTools/components/TelemetryDictionary/reducer';
import telemetryReports from './screens/Reports/components/TelemetryPowerMonitoring/store/reducer';
import plazaReport from './screens/Reports/components/PlazaReport/store/reducer';
import configUpdate from './screens/ConfigUpdate/store/reducer';

const i2p2App = () =>
  combineReducers({
    dictionaries,
    form: formReducer,
    dashboard,
    chargersList,
    multiFwUpdateList,
    login,
    deployCheck,
    rapidSearch,
    accounts,
    fwPackages,
    profile,
    statistics,
    chargerDetails,
    ssplists,
    appConfig,
    firmwareUpdateDialog,
    drillDownChart,
    plazaTopology,
    logEvents,
    plazaGraphs,
    plazaChargerList,
    plazaView,
    roles,
    idle,
    advancedSearch,
    parametersSchema,
    chargerPackages,
    reports,
    alert,
    notification,
    confirm,
    ssoAccounts,
    telemetryMetrics,
    chargerTelemetry: ChargerTelemetryReducer,
    telemetryReports,
    screenBlocker,
    plazaReport,
    configUpdate,
  });

export default i2p2App;
